import { createEntityStmtInstruction } from './CreateEntityStmt';
import { removeEntityStmtInstruction } from './RemoveEntityStmt';
import { renameEntityStmtInstruction } from './RenameEntityStmt';
export const entityInstruction = `
### Entity commands

${createEntityStmtInstruction}
${removeEntityStmtInstruction}
${renameEntityStmtInstruction}
`;
//# sourceMappingURL=entityInstruction.js.map